import React from 'react'
import "./notfound.css"
function NotFound() {
    return (
        <div className='not-found'>movie Not Found</div>
    )
}

export default NotFound